import React, { useCallback, useState } from "react";
import "./App.css"; // Zorg ervoor dat je Tailwind CSS hebt toegevoegd
import { DynamicForm } from "./form/DynamicForm";
import { ConfiguratorContainer } from "./configurator/ConfiguratorContainer";
import { OrderSummary } from "./order/OrderSummary";
import { TotalPrice } from "./order/TotalPrice";
import { FormProvider, useForm } from "react-hook-form";
import { calculate_price } from "@myproject/shared";

const default_orders = [];

function App() {
  const methods = useForm({mode: "onSubmit"});

  const [orders, setOrders] = useState(default_orders);
  const [page, setPage] = useState("CONFIGURATOR");

  console.log("rerender app.js")

  const remove_opmeting = () => {
    const new_orders = [...orders];
    setOrders(new_orders.map((no) => ({ ...no, OPMETING: false })));
  };

  const add_order = (order) => {
    const new_orders = [...orders];
    const new_order = calculate_price(order);
    console.log(new_order);
    new_orders.push(new_order);
    setOrders(new_orders);
  };

  const placeOrder = () => {
    console.log(placeOrder);
    if(orders.length > 0){
    fetch("/api/hello", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(orders),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Betaallink:", data.invoiceUrl);
        window.location.href = data.invoiceUrl; // Stuur klant direct naar betaling
      });
    }else{
      setPage("SHOPPINGBASKET")
    }

  }

  const remove_from_card = (index) => {
    setOrders((prevOrders) => prevOrders.filter((_, i) => i !== index));
  };

  const RenderContainer = () => {
    switch (page) {
      case "SHOPPINGBASKET":
        return (
          <OrderSummary
            remove_from_card={remove_from_card}
            remove_opmeting={remove_opmeting}
            closeBasket={() => {
              setPage("CONFIGURATOR");
            }}
            orders={orders}
          />
        );
        break;
      default:
        return (
          <DynamicForm
  
            add_order={add_order}
            orders={orders}
            openBasket={() => setPage("SHOPPINGBASKET")}
          />
        );
    }
  };

  return (
<FormProvider
    {...methods}
    >
      <div className="page-container">
        <div className="main-container">
          {/* Left side: 3D Configurator */}
          <div className="configurator">
            <ConfiguratorContainer />
            <div style={{flex: '0.10'}}>
            <div
            
        className="flex items-center p-2 border  mb-2 rounded-lg graywarning"
        role="alert"
      >
        <svg
          className="flex-shrink-0 inline w-4 h-4 me-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
        </svg>
        <span className="sr-only">Info</span>
        <div>
          De werkelijke kleuren kunnen licht afwkijken van de weergave op het scherm.
        </div></div>
      </div></div>
          

          {/* Right side: Form to configure the flying frame */}
          <div className="form-container ">
            <div className="top">
              <RenderContainer />
            </div>

            <div className="bottom bottom-0 w-full static md:relative p-2">
              <div className="bg-blue-600 rounded-lg	text-white">
                <TotalPrice
                placeOrder={placeOrder}
                  orders={orders}
                  openBasket={() => setPage("SHOPPINGBASKET")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      </FormProvider>
  );
}

export default App;
